/** Un formulaire saisit un pourcentage (`3,87`) ; l'API attend un ratio décimal à 6 décimales au plus. */
export function percentToRatio(percent: number): number {
  return Math.round((percent / 100) * 1_000_000) / 1_000_000;
}

export function ratioToPercent(ratio: number): number {
  // `ratio` n'a jamais plus de 6 décimales (contrat de l'API) : arrondir à 6 décimales sur le
  // résultat absorbe le bruit binaire de `ratio * 100` (ex. 0,035 * 100 = 3,5000000000000004).
  return Math.round(ratio * 100 * 1_000_000) / 1_000_000;
}
